// src/pages/admin/AdminLogin.jsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { AnimatedSection } from '../../components/common/AnimatedSection';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding-top: 10%;
  padding-bottom: 8rem;
  @media (max-width: 768px) {
    padding-top: 30%;
  }
`;

const Container = styled.div`
  max-width: 1200px; 
  margin: 0 auto; 
  padding: 0 3rem;
`;

const PageHeader = styled.div`
  text-align: center; 
//   margin-bottom: 4rem; 
  padding: 3rem 0;
`;

const PageTitle = styled.h1`
  font-size: 2rem; 
  font-weight: 700; 
  color: #111; 
  margin-bottom: 1.5rem;
`;

const PageSubtitle = styled.p`
  font-size: 1.1rem; 
  color: #6b7280;
`;

const SectionBox = styled.div`
  border: 1px solid #f3f4f6; 
  border-radius: 12px; 
  padding: 3rem; 
  background: #f9fafb;
  max-width: 520px;
  margin: 0 auto;
`;

const FormGroup = styled.div`
  display: flex; 
  flex-direction: column; 
  margin-bottom: 1.25rem;
`;

const Label = styled.label`
  font-weight: 600; 
  margin-bottom: 0.5rem;
  .required { color: #ef4444; margin-left: 0.25rem; }
`;

const Input = styled.input`
  padding: 0.75rem 1rem; 
  border: 1px solid #d1d5db; 
  border-radius: 8px; 
  font-size: 1rem;
`;

const SubmitButtonWrapper = styled.div`
  display: flex; 
  justify-content: center; 
  margin-top: 2rem;
`;

const SubmitButton = styled.button`
  background: #3b82f6; 
  color: #fff; 
  padding: 0.8rem 2rem; 
  border: none;
  border-radius: 9999px; 
  font-weight: 600; 
  cursor: pointer;
  &:hover { background: #2563eb; }
`;

const ErrorMsg = styled.div`
  color: #b91c1c; 
  margin-top: 0.75rem; 
  text-align: center;
`;

export default function AdminLogin() {
  const API = process.env.REACT_APP_API_BASE || 'http://localhost:8080';
  const nav = useNavigate();

  const [headerRef, headerVisible] = useScrollAnimation();
  const [formRef, formVisible] = useScrollAnimation();

  const [username, setU] = useState('');
  const [password, setP] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    // fetch(`${API}/api/auth/me`, { credentials: 'include' })
    //   .then(r => { if (r.ok) nav('/admin', { replace: true }); });
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    const res = await fetch(`${API}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) return setErr('아이디 또는 비밀번호를 확인하세요.');
    nav('/admin', { replace: true });
  };

  return (
    <PageContainer>
      <Container>
        <AnimatedSection ref={headerRef} isVisible={headerVisible} animation="fadeInUp">
          <PageHeader>
            <PageTitle>관리자 로그인</PageTitle>
            <PageSubtitle>관리자 계정으로 로그인해 주세요.</PageSubtitle>
          </PageHeader>
        </AnimatedSection>

        <AnimatedSection ref={formRef} isVisible={formVisible} animation="fadeInUp" delay="0.2s">
          <form onSubmit={onSubmit} noValidate>
            <SectionBox>
              <FormGroup>
                <Label>아이디<span className="required">*</span></Label>
                <Input
                  value={username}
                  onChange={e => setU(e.target.value)}
                  placeholder="아이디를 입력해 주세요."
                  autoComplete="username"
                />
              </FormGroup>
              <FormGroup>
                <Label>비밀번호<span className="required">*</span></Label>
                <Input
                  type="password"
                  value={password}
                  onChange={e => setP(e.target.value)}
                  placeholder="비밀번호를 입력해 주세요."
                  autoComplete="current-password"
                />
              </FormGroup>

              {err && <ErrorMsg>{err}</ErrorMsg>}

              <SubmitButtonWrapper>
                <SubmitButton type="submit">로그인</SubmitButton>
              </SubmitButtonWrapper>
            </SectionBox>
          </form>
        </AnimatedSection>
      </Container>
    </PageContainer>
  );
}
